import useResizeObserverFromLib from 'ui-library/hooks/useResizeObserver';

/*
 * Wrapper around the use-resize-observer hook which allows it to be stubbed.
 */
export const useResizeObserver: typeof useResizeObserverFromLib = (opts) => useResizeObserverFromLib(opts);
